import { motion } from "framer-motion";
import styled from "styled-components";

import { TABLET_MAX } from "../../styles/breakpoints";

/* Panel that sits between MobileTopBar (80px) and BottomNavBar (72px).
   AnimatePresence handles mount/unmount — no display:none toggle needed. */
export const DrawerPanel = styled(motion.div)`
  flex-direction: column;
  position: fixed;
  top: 80px;
  bottom: 72px;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 1035;
  overflow-y: auto;
  display: flex;
`;

export const DrawerBody = styled(motion.div)`
  flex: 1;
  padding: 8px 0;
  overflow-y: auto;
`;

export const DrawerGroup = styled(motion.div)`
  margin-bottom: 4px;
`;

export const DrawerGroupTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #8a94a7;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 12px 20px 6px;
`;

export const DrawerLinkItem = styled.a`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 20px;
  text-decoration: none;
  color: ${({ active }) => (active ? "#2266ef" : "#3d4d69")};
  background: ${({ active }) => (active ? "#EDF8FE" : "transparent")};
  border: 1px solid ${({ active }) => (active ? "#2266ef" : "transparent")};
  font-size: 14px;
  font-weight: ${({ active }) => (active ? "600" : "500")};
  border-radius: 32px;
  margin: 0 8px;
  transition: background 0.12s;

  &:hover {
    background: #f4f6f9;
    color: #3d4d69;
    text-decoration: none;
  }
`;

export const DrawerLinkIcon = styled.img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

export const DrawerCollapseGroup = styled.div``;

export const DrawerCollapseHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 20px;
  color: #3d4d69;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  margin: 0 8px;

  &:hover {
    background: #f4f6f9;
  }
`;

export const DrawerCollapseChildren = styled.div`
  padding-left: 12px;
`;

export const DrawerCollapseChildLink = styled.a`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px 10px 20px;
  text-decoration: none;
  color: ${({ active }) => (active ? "#2266ef" : "#3d4d69")};
  background: ${({ active }) => (active ? "#EDF8FE" : "transparent")};
  border: 1px solid ${({ active }) => (active ? "#2266ef" : "transparent")};
  font-size: 13px;
  font-weight: ${({ active }) => (active ? "600" : "400")};
  border-radius: 32px;
  margin: 0 8px;
  transition: background 0.12s;

  &:hover {
    background: #f4f6f9;
    text-decoration: none;
    color: #3d4d69;
  }
`;

export const DrawerChildMiniIcon = styled.div`
  text-transform: uppercase;
  width: 24px;
  height: 24px;
  font-size: 10px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: ${({ active }) =>
    active ? "#2266ef" : "rgba(61, 77, 105, 0.3)"};
  color: ${({ active }) => (active ? "#fff" : "#ffffff")};
  flex-shrink: 0;
`;

export const DrawerFooter = styled.div`
  padding: 12px 16px;
  border-top: 1px solid #e0e0e0;
`;

export const OrgSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 4px;
`;

export const OrgIconBadge = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: ${({ bgColor }) => bgColor || "#3b3f48"};
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const OrgName = styled.span`
  font-size: 13px;
  color: #3d4d69;
  font-weight: 500;
`;
